// Controllers for admin utility features: App Maintenance and Force Update
// (app version). All endpoints are authenticated (bearer token via authAxios).
//
// Backend (MSFA_NODE_BACKEND):
//   Maintenance : controllers/utilities/maintainenceController.js
//   App Version : controllers/utilities/appVersionController.js

import { authAxios } from "setups/axios";

// ── App Maintenance ─────────────────────────────────────────────────────────

// Latest maintenance record (backend returns the newest by createdAt).
export const getMaintenance = async () => {
  const response = await authAxios()({
    url: `/api/v1/maintenance/checkMaintenance`,
    method: "GET",
  });
  return response?.data;
};

// Create a new maintenance record. The newest record is the source of truth,
// so disabling maintenance means posting a record with maintenanceMode:false.
export const addMaintenance = async (payload) => {
  const response = await authAxios()({
    url: `/api/v1/maintenance/addMaintenance`,
    method: "POST",
    data: payload,
  });
  return response?.data;
};

// ── App Version (Force Update) ──────────────────────────────────────────────

// All app-version records (history), newest first is not guaranteed by the API,
// so callers should sort by createdAt if they need ordering.
export const getAppVersions = async () => {
  const response = await authAxios()({
    url: `/api/v1/appversion/getAppVersion`,
    method: "GET",
  });
  return response?.data;
};

// Latest app-version config the mobile apps actually read.
export const checkAppVersion = async () => {
  const response = await authAxios()({
    url: `/api/v1/appversion/checkAppVersion`,
    method: "GET",
  });
  return response?.data;
};

// Create a new app-version record. Because checkAppVersion returns the most
// recent record, creating a new one effectively publishes the current config.
export const addAppVersion = async (payload) => {
  const response = await authAxios()({
    url: `/api/v1/appversion/addAppVersion`,
    method: "POST",
    data: payload,
  });
  return response?.data;
};

// Update an existing app-version record by id.
export const updateAppVersion = async (id, payload) => {
  const response = await authAxios()({
    url: `/api/v1/appversion/updateAppVersion/${id}`,
    method: "PUT",
    data: payload,
  });
  return response?.data;
};
